import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const brand = {
  primary: "#0b1f1a",
  accent: "#0e918c",
};

const VerificationCompletePage = () => {
  const navigate = useNavigate();
  const [redirecting, setRedirecting] = useState(true);
  const deepLinkWorked = useRef(false);

  useEffect(() => {
    const onBlur = () => { deepLinkWorked.current = true; };
    window.addEventListener("blur", onBlur);

    const timer = setTimeout(() => {
      window.location.href = "civixthread://verification-complete";
      setTimeout(() => {
        if (!deepLinkWorked.current) {
          setRedirecting(false);
        }
      }, 1000);
    }, 500);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("blur", onBlur);
    };
  }, []);

  const handleReturnToApp = () => {
    if (deepLinkWorked.current) {
      window.location.href = "civixthread://verification-complete";
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8fafc",
        padding: 3,
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: 3,
          padding: 5,
          maxWidth: 400,
          width: "100%",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
        }}
      >
        {/* Success Icon */}
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            backgroundColor: `${brand.accent}15`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 24px auto",
          }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: 48,
              color: brand.accent,
            }}
          />
        </Box>

        {/* Title */}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: brand.primary,
            marginBottom: 2,
          }}
        >
          Verification Complete!
        </Typography>

        {/* Message */}
        <Typography
          sx={{
            color: "#64748b",
            fontSize: 16,
            lineHeight: 1.6,
            marginBottom: 3,
          }}
        >
          {redirecting
            ? "Returning you to the app..."
            : "Your identity has been verified. You're all set!"}
        </Typography>

        {/* Loading or Button */}
        {redirecting ? (
          <CircularProgress
            size={24}
            sx={{
              color: brand.accent,
            }}
          />
        ) : (
          <>
            <Button
              variant="contained"
              onClick={handleReturnToApp}
              sx={{
                backgroundColor: brand.accent,
                color: "#ffffff",
                fontWeight: 600,
                padding: "12px 32px",
                borderRadius: 2,
                textTransform: "none",
                fontSize: 15,
                "&:hover": {
                  backgroundColor: brand.primary,
                },
              }}
            >
              Go to Dashboard
            </Button>

            <Typography
              sx={{
                color: "#94a3b8",
                fontSize: 14,
                marginTop: 3,
              }}
            >
              Your verification status will update automatically.
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};

export default VerificationCompletePage;

